import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "amount_due": {
      "column": null,
      "name": "amount_due",
      "selected_by_default": null,
      "translated": null
    },
    "application_fee_amount": {
      "column": null,
      "name": "application_fee_amount",
      "selected_by_default": null,
      "translated": null
    },
    "created": {
      "column": {
        "default": null,
        "name": "created",
        "null": false,
        "type": "datetime"
      },
      "name": "created",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "ending_balance": {
      "column": {
        "default": null,
        "name": "ending_balance",
        "null": true,
        "type": "integer"
      },
      "name": "ending_balance",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "paid": {
      "column": {
        "default": null,
        "name": "paid",
        "null": false,
        "type": "boolean"
      },
      "name": "paid",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_customer_id": {
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_customer_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_discount_id": {
      "column": {
        "default": null,
        "name": "stripe_discount_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_discount_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    },
    "subtotal": {
      "column": null,
      "name": "subtotal",
      "selected_by_default": null,
      "translated": null
    },
    "tax": {
      "column": null,
      "name": "tax",
      "selected_by_default": null,
      "translated": null
    },
    "total": {
      "column": null,
      "name": "total",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeInvoice",
  "collectionKey": "stripe_invoices",
  "collectionName": "stripe_invoices",
  "i18nKey": "stripe_invoice",
  "camelizedLower": "stripeInvoice",
  "name": "StripeInvoice",
  "nameDasherized": "stripe-invoice",
  "pluralName": "stripe_invoices",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": "stripe_customer"
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "invoice_pdf_file_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "invoice_pdf_file_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "invoice_pdf_file_attachment"
    },
    {
      "className": "StripeCharge",
      "collectionName": "stripe_charges",
      "foreignKey": "stripe_charge_id",
      "name": "stripe_charge",
      "macro": "belongs_to",
      "resource_name": "StripeCharge",
      "through": null
    },
    {
      "className": "StripeCharge",
      "collectionName": "stripe_charges",
      "foreignKey": "stripe_invoice_id",
      "name": "stripe_charges",
      "macro": "has_many",
      "resource_name": "StripeCharge",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_discount",
      "macro": "belongs_to",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeInvoiceItem",
      "collectionName": "stripe_invoice_items",
      "foreignKey": "stripe_invoice_id",
      "name": "stripe_invoice_items",
      "macro": "has_many",
      "resource_name": "StripeInvoiceItem",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription",
      "macro": "belongs_to",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount_due_cents",
      "column": {
        "default": null,
        "name": "amount_due_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "amount_due_currency",
      "column": {
        "default": null,
        "name": "amount_due_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "amount_paid_cents",
      "column": {
        "default": null,
        "name": "amount_paid_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_paid_currency",
      "column": {
        "default": null,
        "name": "amount_paid_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "amount_remaining_cents",
      "column": {
        "default": null,
        "name": "amount_remaining_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_remaining_currency",
      "column": {
        "default": null,
        "name": "amount_remaining_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "application_fee_amount_cents",
      "column": {
        "default": null,
        "name": "application_fee_amount_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "application_fee_amount_currency",
      "column": {
        "default": null,
        "name": "application_fee_amount_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "attempt_count",
      "column": {
        "default": null,
        "name": "attempt_count",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "attempted",
      "column": {
        "default": null,
        "name": "attempted",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "auto_advance",
      "column": {
        "default": "0",
        "name": "auto_advance",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "billing_deprecated",
      "column": {
        "default": null,
        "name": "billing_deprecated",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "billing_reason",
      "column": {
        "default": null,
        "name": "billing_reason",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "closed",
      "column": {
        "default": null,
        "name": "closed",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "collection_method",
      "column": {
        "default": null,
        "name": "collection_method",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "due_date",
      "column": {
        "default": null,
        "name": "due_date",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "ending_balance",
      "column": {
        "default": null,
        "name": "ending_balance",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "ending_balance_cents",
      "column": {
        "default": null,
        "name": "ending_balance_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "ending_balance_currency",
      "column": {
        "default": null,
        "name": "ending_balance_currency",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "finalized_at",
      "column": {
        "default": null,
        "name": "finalized_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "forgiven",
      "column": {
        "default": null,
        "name": "forgiven",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "hosted_invoice_url",
      "column": {
        "default": null,
        "name": "hosted_invoice_url",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "invoice_pdf",
      "column": {
        "default": null,
        "name": "invoice_pdf",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "marked_uncollectible_at",
      "column": {
        "default": null,
        "name": "marked_uncollectible_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "next_payment_attempt",
      "column": {
        "default": null,
        "name": "next_payment_attempt",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "number",
      "column": {
        "default": null,
        "name": "number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "paid",
      "column": {
        "default": null,
        "name": "paid",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "paid_at",
      "column": {
        "default": null,
        "name": "paid_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "period_end",
      "column": {
        "default": null,
        "name": "period_end",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "period_start",
      "column": {
        "default": null,
        "name": "period_start",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "receipt_number",
      "column": {
        "default": null,
        "name": "receipt_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "starting_balance",
      "column": {
        "default": null,
        "name": "starting_balance",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "starting_balance_cents",
      "column": {
        "default": null,
        "name": "starting_balance_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "starting_balance_currency",
      "column": {
        "default": null,
        "name": "starting_balance_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "statement_descriptor",
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "status",
      "column": {
        "default": "draft",
        "name": "status",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_charge_id",
      "column": {
        "default": null,
        "name": "stripe_charge_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_discount_id",
      "column": {
        "default": null,
        "name": "stripe_discount_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_subscription_id",
      "column": {
        "default": null,
        "name": "stripe_subscription_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "subscription_proration_date",
      "column": {
        "default": null,
        "name": "subscription_proration_date",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "subtotal_cents",
      "column": {
        "default": null,
        "name": "subtotal_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "subtotal_currency",
      "column": {
        "default": null,
        "name": "subtotal_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tax_cents",
      "column": {
        "default": null,
        "name": "tax_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tax_currency",
      "column": {
        "default": null,
        "name": "tax_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tax_percent",
      "column": {
        "default": null,
        "name": "tax_percent",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "total_cents",
      "column": {
        "default": null,
        "name": "total_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "total_currency",
      "column": {
        "default": null,
        "name": "total_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "voided_at",
      "column": {
        "default": null,
        "name": "voided_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "webhooks_delivered_at",
      "column": {
        "default": null,
        "name": "webhooks_delivered_at",
        "null": true,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": "stripe_customer"
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_discount",
      "macro": "belongs_to",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeInvoiceItem",
      "collectionName": "stripe_invoice_items",
      "foreignKey": "stripe_invoice_id",
      "name": "stripe_invoice_items",
      "macro": "has_many",
      "resource_name": "StripeInvoiceItem",
      "through": null
    }
  ],
  "paramKey": "stripe_invoice",
  "primaryKey": "id"
}

/** Frontend model for StripeInvoice. */
class StripeInvoice extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  amountDue() {
    return this.readAttributeUnderscore("amount_due")
  }

  /** @returns {boolean} */
  hasAmountDue() {
    const value = this.amountDue()

    return this._isPresent(value)
  }

  /** @returns {any} */
  applicationFeeAmount() {
    return this.readAttributeUnderscore("application_fee_amount")
  }

  /** @returns {boolean} */
  hasApplicationFeeAmount() {
    const value = this.applicationFeeAmount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  created() {
    return this.readAttributeUnderscore("created")
  }

  /** @returns {boolean} */
  hasCreated() {
    const value = this.created()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  endingBalance() {
    return this.readAttributeUnderscore("ending_balance")
  }

  /** @returns {boolean} */
  hasEndingBalance() {
    const value = this.endingBalance()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  paid() {
    return this.readAttributeUnderscore("paid")
  }

  /** @returns {boolean} */
  hasPaid() {
    const value = this.paid()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeCustomerId() {
    return this.readAttributeUnderscore("stripe_customer_id")
  }

  /** @returns {boolean} */
  hasStripeCustomerId() {
    const value = this.stripeCustomerId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeDiscountId() {
    return this.readAttributeUnderscore("stripe_discount_id")
  }

  /** @returns {boolean} */
  hasStripeDiscountId() {
    const value = this.stripeDiscountId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subtotal() {
    return this.readAttributeUnderscore("subtotal")
  }

  /** @returns {boolean} */
  hasSubtotal() {
    const value = this.subtotal()

    return this._isPresent(value)
  }

  /** @returns {any} */
  tax() {
    return this.readAttributeUnderscore("tax")
  }

  /** @returns {boolean} */
  hasTax() {
    const value = this.tax()

    return this._isPresent(value)
  }

  /** @returns {any} */
  total() {
    return this.readAttributeUnderscore("total")
  }

  /** @returns {boolean} */
  hasTotal() {
    const value = this.total()

    return this._isPresent(value)
  }

  /** @returns {import("./account.js").default | null} */
  account() {
    return this._readHasOneReflection({reflectionName: "account"})
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  loadAccount() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const modelClass = modelClassRequire("Account")

    return this._loadHasOneReflection(
      {reflectionName: "account", model: this, modelClass},
      {
        params: {
          through: {
            model: "StripeInvoice",
            id,
            reflection: "account"
          }
        }
      }
    )
  }

  /** @returns {import("./stripe-customer.js").default | null} */
  stripeCustomer() {
    return this._readBelongsToReflection({reflectionName: "stripe_customer"})
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  loadStripeCustomer() {
    if (!("stripeCustomerId" in this)) throw new Error("Foreign key method wasn't defined: stripeCustomerId")

    const id = this.stripeCustomerId()
    const modelClass = modelClassRequire("StripeCustomer")
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "stripe_customer", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./stripe-discount.js").default | null} */
  stripeDiscount() {
    return this._readBelongsToReflection({reflectionName: "stripe_discount"})
  }

  /** @returns {Promise<import("./stripe-discount.js").default | null>} */
  loadStripeDiscount() {
    if (!("stripeDiscountId" in this)) throw new Error("Foreign key method wasn't defined: stripeDiscountId")

    const id = this.stripeDiscountId()
    const modelClass = modelClassRequire("StripeDiscount")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "stripe_discount", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./stripe-invoice-item.js").default>} */
  stripeInvoiceItems() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const modelClass = modelClassRequire("StripeInvoiceItem")

    const ransack = {}

    ransack["stripe_invoice_id_eq"] = this.stripeId()

    return new Collection(
      {
        reflectionName: "stripe_invoice_items",
        model: this,
        modelName: "StripeInvoiceItem",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-invoice-item.js").default>>} */
  loadStripeInvoiceItems() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const modelClass = modelClassRequire("StripeInvoiceItem")

    const ransack = {}

    ransack["stripe_invoice_id_eq"] = this.stripeId()

    return this._loadHasManyReflection(
      {
        reflectionName: "stripe_invoice_items",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default StripeInvoice
